import { Fetcher } from '@pp/core/src/api/Fetcher';

import { InGameHistoryType } from './types';

export interface InGameHistoryParams {
  JSESSIONID: string;
  tableId: string;
  rowStart: number;
  rowEnd: number;
  url: string;
  force: boolean;
}

export const inGameHistoryData = ({
  JSESSIONID,
  tableId,
  rowStart,
  rowEnd,
  url,
  force,
}: InGameHistoryParams): Promise<InGameHistoryType> => {
  return Fetcher.fetch<InGameHistoryType>(url, {
    params: {
      JSESSIONID,
      tableId,
      rowStart,
      rowEnd,
    },
    force: force,
  });
};
